import styled, { keyframes } from "styled-components";

export const Checkbox = styled("div")`
  display: flex;
  position: relative;
  flex-direction: column;
  min-height: 20px;
  min-width: 20px;
`;

const checkboxCheck = keyframes`
  0%{
    width: 0;
    height: 0;
    border-color: white;
    transform: translate3d(0,0,0) rotate(45deg);
  }
  33%{
    width: 8px;
    height: 10px;
    transform: translate3d(-4px,-8px,0) rotate(45deg);
  }
  100%{    
    width: 8px;
    height: 16px;    
    border-color: white;
    transform: translate3d(-8px,-15px,0) rotate(45deg);
}`;

export const Input = styled("input")`
  display: none;
  position: relative;
  height: 20px;
  width: 20px !important;

  &:not(:disabled) {
    &:focus ~ label > span,
    &:active ~ label > span {
      border: 2px solid ${({ theme }) => theme.colors.PrimaryLight};
      background: transparent;
    }

    &:checked ~ label > span {
      border: 1px solid ${({ theme }) => theme.colors.Primary};
      background-color: ${({ theme }) => theme.colors.Primary};

      &:before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        zoom: 0.75;
        border-radius: 1.5px;
        border-right: 3px solid transparent;
        border-bottom: 3px solid transparent;
        transform: rotate(45deg) translate(-50%, -50%);
        transform-origin: 0% 100%;
        animation: ${checkboxCheck} 125ms 250ms cubic-bezier(0.4, 0, 0.23, 1)
          forwards;
      }
    }
  }

  &:disabled {
    & ~ span {
      border: 2px solid rgba(0, 0, 24, 0.08);
    }
  }
`;

export const OptionLabel = styled("label")`
  position: relative;
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  color: rgba(0, 0, 24, 0.84);
  min-height: 20px;
  z-index: 2;

  font-size: 14px;
  line-height: 18px;
`;

export const Checkmark = styled("span")`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  width: 19px;
  height: 19px;
  background: transparent;
  border: 1px solid #9e9e9e;
  border-radius: 4px;
  cursor: pointer;
  transition: all 250ms cubic-bezier(0.4, 0, 0.23, 1);
`;
